import React from 'react';
import clsx from 'clsx';
import Image from 'next/image';

import { BaseComponentProps } from '@utils/types/baseComponents';
import { ListingType } from '@utils/types/listing';
import { getBedIcon } from '@components/_shared/sleepingSpaces/helpers';

import styles from './styles.module.scss';

type Props = {
  items: ListingType['sleeping_arrangements'];
} & BaseComponentProps;

SleepingSpaces.defaultProps = {};

export default function SleepingSpaces(props: Props) {
  const { containerStyle, items } = props;

  return (
    <div className={clsx([styles.sleepingSpaces, containerStyle])}>
      {items.map((bed, key) => {
        const type = Object.keys(bed.types)[0];
        const beds = Object.entries(bed.types).map(([key, value]) => {
          return `${value?.count || 1} ${key}`;
        });
        const count = bed.types[type]?.count || 0;
        return (
          <div
            key={`sleeping-space--${key}`}
            className={styles.sleepingSpaces__item}
          >
            <div className={styles.sleepingSpaces__icon}>
              <Image src={getBedIcon(type)} alt={type} layout="fill" />
            </div>

            <div className={styles.sleepingSpaces__title}>
              {`Bedroom ${key + 1}, ${beds.join(', ')}`}
            </div>
          </div>
        );
      })}
    </div>
  );
}
